import { areDatesEqual } from "./AreDatesEqual";
/**
 * Gets a calendar for a given month and year with some days from the previous and next month
 * @param month
 * @param year
 */
export function getCalendar(month, year) {
    var today = new Date();
    var startDate = new Date(year, month, 1);
    while (startDate.getDay() !== 1) {
        startDate.setDate(startDate.getDate() - 1);
    }
    var endDate = new Date(year, month + 1, 0);
    while (endDate.getDay() !== 0) {
        endDate.setDate(endDate.getDate() + 1);
    }
    var calendar = [];
    var currentWeek = [];
    for (var date = startDate; date <= endDate; date.setDate(date.getDate() + 1)) {
        currentWeek.push({
            date: new Date(date),
            // isCurrentMonth: date.getMonth() === month,
            isCurrentDay: areDatesEqual(date, today)
        });
        if (currentWeek.length === 7) {
            calendar.push(currentWeek);
            currentWeek = [];
        }
    }
    return calendar;
}
